import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/itemAta'

class ItemAtaApiClient {
	async buscarListagem(filtro, paginacao) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}`,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(url)
	}

	async excluir(dados) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}`,
		}).build()
		return await axios.delete(url, { data: dados })
	}

	async inserirComProcesso(dados) {
		return await axios.post(`${URL_PATH}/comProcesso`, dados)
	}

	async buscarAcessoHistoricoBotoes(idItemAta) {
		return await axios.get(`${URL_PATH}/${idItemAta}/acesso-historico-botoes`)
	}

	async salvarInformacoesPrazoEntrega(payload) {
		return await axios.put(`${URL_PATH}`, payload)
	}
}
export default new ItemAtaApiClient()
